import { axios } from "utils";

import { ADMIN_NOTIFICATIONS_URL as endpoint } from "consts";

export const getAllNotifications = async (data) => axios.get(`${endpoint}`, { data });

export const addNotification = async (data) => axios.post(`${endpoint}`, { data });

export const getNotification = async (data) => axios.get(`${endpoint}/${data.id}`, { data });

export const updateNotification = async (data) => axios.put(`${endpoint}/${data.id}`, { data });

export const deleteNotification = async (data) => axios.delete(`${endpoint}/${data.id}`, { data });

export const sendNotification = async (data) => axios.post(`${endpoint}/send`, { data });
